import { render, staticRenderFns } from "./bind-tel-dialog.vue?vue&type=template&id=406645a9&"
import script from "./bind-tel-dialog.vue?vue&type=script&lang=js&"
export * from "./bind-tel-dialog.vue?vue&type=script&lang=js&"
import style0 from "./bind-tel-dialog.vue?vue&type=style&index=0&id=406645a9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports